export class RequestLimitExceededError extends Error {
  constructor() {
    super('Request limit exceeded');
  }
}
